/**
 * Initialize the products carousel using Slick
 * Requires jQuery and Slick to be loaded (via CDN in HTML)
 */
export function initCarousel() {
  // Wait for jQuery and Slick to be available
  if (typeof window.$ === 'undefined' || typeof window.$.fn.slick === 'undefined') {
    console.warn('jQuery or Slick carousel not loaded. Carousel will not initialize.');
    return;
  }

  const carousel = document.querySelector('.home--carousel-slides');
  if (!carousel) return;

  // Check if already initialized to avoid re-initialization
  if (window.$(carousel).hasClass('slick-initialized')) {
    return;
  }

  window.$(carousel).slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    prevArrow: window.$('.home--carousel-wrap .prev'),
    nextArrow: window.$('.home--carousel-wrap .next'),
    dots: true,
    infinite: true,
    centerMode: false,
    responsive: [
      { 
        breakpoint: 900, 
        settings: { 
          slidesToShow: 2,
          slidesToScroll: 2
        } 
      },
      { 
        breakpoint: 600, 
        settings: { 
          slidesToShow: 1,
          slidesToScroll: 1
        } 
      }
    ]
  });
}
